'use strict';

var React = require('react');
var ComboBoxBase = require('../common/ComboBoxBase');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');
var appTypes = require('../../types/appTypes');
var ReactDOM = require('react-dom');

var ComboBox = React.createClass({
  parseText: function () {
    var arr = util.Text.delimitToParagraphs(this.props.text);
    var i;
    for (i = 0; i < arr.length; i++) {
      arr[i] = util.Text.convertSpaceToNbsp(arr[i]);
    }
    return arr;
  },

  render: function () {
    var textItems = this.parseText();
    var props = {
      items: textItems,
      borderColor: this.props.borderColor,
      color: this.props.textColor,
      backgroundColor: this.props.color,
      fontSize: this.props.textSize,
      fontFamily: this.props.textFontFamily,
      selectedIndex: this.props.selectedIndex,
      width: styleHelper.getWidth(this.props),
      height: styleHelper.getHeight(this.props),
      onItemClick: this.onItemClick
    };
    if (this.props.textStyles) {
      props.fontWeight = this.props.textStyles.fontWeight;
      props.fontStyle = this.props.textStyles.fontStyle;
      props.textDecoration = this.props.textStyles.textDecoration;
    }
    return (
      <ComboBoxBase ref="combobox" {...props}/>
    );
  },
  onItemClick: function (e, index) {
    this.props.events.doSelfClick(e, this.props, 'interactive-link', index);
  },

  componentDidMount : function(){
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE,this.onResize);
  },

  onResize : function(e){
    $(ReactDOM.findDOMNode(this.refs.combobox)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
  }
});

module.exports = ComboBox;


/** WEBPACK FOOTER **
 ** ./src/views/Components/ComboBox.jsx
 **/